<template>
  <section>
    <header v-on:click="sectionClicked">
      <div class="cnt">
        <router-link to="/" class="logo">
          <img src="../assets/logo-tufi-long.png">
        </router-link>
        <div class="menuCnt">
          <div class="theMenu" :class="{open: menuOpen}">
            <div class="close" v-on:click="menuOpen = false"></div>
            <div class="menuHeader">Menu</div>
            <div class="menuItem home">
              <router-link to="/">Home</router-link>
            </div>
            <div class="menuItem" :class="{active: menu === 'teamUp'}">
              <router-link to="/team-up-everyday">TEAM UP EVERYDAY
                <span class="new">NEW</span>
              </router-link>
            </div>
            <div class="menuItem" :class="{active: menu === 'teamUpForYouth'}">
              <router-link to="/team-up-for-youth">TEAM UP For Youth</router-link>
            </div>
            <div class="menuItem" :class="{active: menu === 'feed'}">
              <router-link to="/untukmubumiku">#Untukmubumiku</router-link>
            </div>
            <div class="menuItem" :class="{active: menu === 'blog'}">
              <router-link to="/blog">BLOG</router-link>
            </div>
          </div>
          <div :class="{searchCnt: true, open: searchOpen, loggedIn: loggedIn}"
            v-on:click.stop="doNothing">
            <form v-on:submit.prevent="search" action="/search"
              :class="{searchLoading: searchLoading}">
              <input type="text" placeholder="Pencarian..."
                name="q" autocomplete="off" spellcheck="off" v-model="query"
                ref="search" v-on:input="search" v-on:focus="search" v-on:click.stop="doNothing">
              <div class="searchLoading"></div>
              <div class="closeSearch" v-on:click.stop="searchOpen = false"></div>
              <button type="button" v-on:click.stop="openSearch"></button>
            </form>
            <div class="searchOverlay" v-if="viewSearchDd"></div>
            <perfect-scrollbar class="searchDd" v-if="viewSearchDd">
              <div class="searchLoading" v-if="searchLoading"></div>
              <div class="notFound" v-else-if="searchResults.length < 1">
                <h4>Tidak ada hasil ditemukan</h4>
                <p>Apa yang kamu cari sepertinya tidak ada, coba ganti kata kunci pencarian.</p>
              </div>
              <div v-else>
                <li v-for="(item, i) in searchResults" :key="i"
                  :class="item.type" v-on:click.stop="selectSearch(item)">
                  <div v-if="item.title">
                    <div class="icon" :style="{'background-image': `url(${item.imageUrl})`}"
                      v-if="item.imageUrl && item.imageUrl !== ''"></div>
                    <div class="icon noImg" v-else></div>
                    {{item.title}}
                    <div class="label">Blog Post</div>
                  </div>
                  <div v-else>
                    <div class="icon teamUp" :style="{'background-image':
                      `url(${item.media.imageTh})`, 'background-color': item.color}"
                      v-if="item.media && item.media.imageTh"></div>
                    <div class="icon" :style="{'background-color': item.color}"
                      v-else></div>
                    {{item.name}}
                    <div class="label">Team Up For Impact Everyday</div>
                  </div>
                </li>
              </div>
            </perfect-scrollbar>
          </div>
          <div class="accountCnt" :class="{loggedIn: loggedIn}">
            <button type="button" class="loginBtn" v-if="!loggedIn"
              v-on:click="login">Masuk</button>
            <div class="profile" v-else-if="user.avatar"
              :style="{'background-image': `url(${user.avatar})`}"
              v-on:click.stop="userMenuOpen = !userMenuOpen"></div>
            <div class="profile" v-else
              :style="{'background-color': pC[pCIdx]}"
              v-on:click.stop="userMenuOpen = !userMenuOpen">
              <span v-if="user.name">{{user.name.substr(0, 2)}}</span>
            </div>
            <div class="accountMenu" v-if="userMenuOpen"
              v-on:click.stop="doNothing">
              <div class="accMenuHeader">
                <div class="pictCnt">
                  <div :class="{thePict: 1, hasPhoto: user.avatar}"
                    :style="{'background-image': `url(${user.avatar})`,
                    'background-color': pC[pCIdx]}">
                    <span v-if="user.name">{{user.name.substr(0, 2)}}</span>
                  </div>
                </div>
                <h4>{{user.name}}</h4>
                <h5>{{user.email}}</h5>
              </div>
              <div class="divider"></div>
              <li class="amItem" v-on:click="editProfile">Edit Profil</li>
              <div class="divider"></div>
              <a href="/team-up-everyday" class="amItem">Team Up Everyday</a>
              <a href="/team-up-for-youth" class="amItem">Team Up For Youth</a>
              <a href="/untukmubumiku" class="amItem">#UntukmuBumiku</a>
              <a href="/blog" class="amItem">Blog</a>
              <div class="divider"></div>
              <a href="/privacy-policy" class="amItem">Kebijakan Privasi</a>
              <a href="/term-of-use" class="amItem">Syarat Penggunaan</a>
              <div class="divider"></div>
              <li class="amItem" style="color: red;"
                v-on:click.stop="signOut">Keluar</li>
            </div>
          </div>
          <div class="menuOverlay" v-if="menuOpen" v-on:click="menuOpen = false"></div>
          <div class="menuToggle" v-on:click="menuOpen = true"></div>
        </div>
      </div>
    </header>
    <Confirmation ref="confirmDialog"/>
    <LoginModal ref="login"/>
    <LoadingDialog ref="loadingDialog"/>
    <Account ref="account"/>
  </section>
</template>

<script>
import Confirmation from '@/components/Confirmation.vue';
import LoginModal from '@/components/LoginModal.vue';
import LoadingDialog from '@/components/LoadingDialog.vue';
import Account from '@/components/Account.vue';

export default {
  components: {
    Confirmation,
    LoginModal,
    LoadingDialog,
    Account,
  },
  props: ['menu'],
  data() {
    return {
      menuOpen: false,

      /**
       * User
       *
       */
      user: { avatar: '', name: '', email: '' },
      pC: ['#5051a2', '#fdbb30', '#1e7f69', '#f14724'],
      pCIdx: 0,
      loggedIn: false,
      userMenuOpen: false,

      /**
       * Search
       *
       */
      searchOpen: false,
      viewSearchDd: false,
      query: '',
      searchLoading: false,
      searchTimer: null,
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {
      this.closeSearch();
      this.userMenuOpen = false;
    },
    search() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        if (!this.query || this.query === '') {
          this.searchLoading = false;
          this.viewSearchDd = false;
          return;
        }
        this.searchLoading = true;
        this.$http.post(this.$config.uri('misc/search'), {
          q: this.query,
        }).then((r) => {
          this.searchResults = (r.data.status === 200) ? r.data.data : [];
          this.searchLoading = false;
          this.viewSearchDd = true;
        });
      }, 500);
    },
    login(f, n) {
      this.$refs.login.open(f, n);
    },
    editProfile() {
      this.userMenuOpen = false;
      this.$refs.account.open(null, () => {
        this.user.avatar = this.$session.get('tufi2_avatar');
        this.user.name = this.$session.get('tufi2_name');
      });
    },
    closeSearch() {
      if (this.searchOpen) {
        this.searchOpen = false;
        return;
      }
      this.search();
    },
    selectSearch(item) {
      if (item.title && (!item.url || item.url === '')) return;
      if (item.title) {
        window.open(item.url, '_blank').focus();
      } else {
        this.$router.push('/team-up-everyday');
      }
    },
    openSearch() {
      this.searchOpen = true;
      setTimeout(() => {
        this.$refs.search.focus();
      }, 300);
    },
    signOut() {
      this.userMenuOpen = false;
      this.$refs.confirmDialog.open({
        title: 'Keluar',
        desc: 'Apakah Anda yakin ingin keluar? Anda dapat masuk kembali kapan aja.',
        action: 'Keluar',
      }, (b) => {
        if (!b) return;
        this.$session.destroy();
        window.location.reload();
      });
    },
  },
  mounted() {
    this.pCIdx = Math.floor(Math.random() * this.pC.length);
    this.loggedIn = this.$session.get('tufi2_jwt');
    this.user.avatar = this.$session.get('tufi2_avatar');
    this.user.email = this.$session.get('tufi2_email') || this.$session.get('tufi2_phone');
    this.user.name = this.$session.get('tufi2_name');
  },
};
</script>

<style scoped lang="scss">
header{
  position: fixed;
  left: 0; right: 0; top: 0;
  z-index: 9991;
  color: #444;
  // background-color: #fff;
  box-sizing: border-box;
  transition: all .3s ease;
  height: 120px;
  .cnt{
    transition: all .3s ease;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    @media (max-width: 1280px) {
      margin: 0;
    }
  }
  @media (max-width: 1280px) {
    padding: 0 20px;
  }
  @media (max-width: 960px) {
    padding: 0 16px;
    height: 60px;
    box-shadow: 0 0 6px rgba(0,0,0,.2);
  }
  a{ color: #444; }
  .menuCnt{
    display: flex;
    padding-top: 6px;
    position: relative;
    @media (max-width: 960px) {
      padding-top: 0;
    }
    @media (max-width: 1080px) {
      padding-right: 0;
    }
    .theMenu{
      display: flex;
      position: relative;
      width: 100%;
      z-index: 9;
      .close{
        position: absolute;
        right: 16px; top: 8px;
        width: 44px; height: 44px;
        text-align: center;
        padding-top: 7px;
        box-sizing: border-box;
        display: none;
        z-index: 7;
        background-size: 16px auto;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url(../assets/close-purple.png);
        cursor: pointer;
        @media (max-width: 1080px) {
          display: block;
        }
      }
      .menuHeader{
        display: none;
      }
      @media (max-width: 1080px) {
        display: block;
        position: fixed;
        right: -320px; top: 0; bottom: 0;
        opacity: 0; width: 320px;
        background-color: #fff;
        z-index: 99;
        box-shadow: 0 0 8px rgba(0, 0, 0, .2);
        padding: 0;
        transition: all .3s ease;
        .menuHeader{
          padding: 20px 25px 17px;
          border-bottom: #eee 1px solid;
          font-size: 18px;
          font-weight: 500;
          margin-bottom: 10px;
          color: #444;
          display: block;
        }
        &.open{
          opacity: 1;
          right: 0;
        }
      }
    }
    .accountCnt{
      padding: 2px 0 0;
      margin-left: 54px;
      position: relative;
      &.loggedIn{
        @media (max-width: 680px) {
          position: absolute;
          margin: 0; right: 0;
        }
      }
      @media (max-width: 1080px) {
        margin-left: 0;
        margin-right: 46px;
      }
      .profile{
        width: 39px; height: 39px;
        background-color: red;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #f14724;
        background-size: cover;
        background-position: center;
        text-transform: uppercase;
        border-radius: 50%;
        color: #fff;
        cursor: pointer;
      }
      .loginBtn{
        height: 39px;
        padding: 0 16px;
        font-size: 18px;
        font-weight: 500;
        border-radius: 3px;
        @media (max-width: 680px) {
          display: none;
        }
      }
      .accountMenu{
        position: absolute;
        background-color: #fff;
        padding: 20px 0 10px;
        color: #444;
        right: -5px; top: 100%;
        box-shadow: 2px 2px 5px rgba(0,0,0,.4);
        width: 320px;
        box-sizing: border-box;
        text-transform: none;
        margin-top: 6px;
        border-radius: 5px;
        z-index: 991;
        @media (max-height: 680px) {
          max-height: 320px;
          margin-top: -16px;
          overflow: auto;
        }
        .accMenuHeader{
          position: relative;
          text-align: left;
          padding-left: 64px;
          .pictCnt{
            display: flex;
            justify-content: center;
            margin-bottom: 10px;
            position: absolute;
            left: 20px; top: -5px;
            .thePict{
              width: 54px; height: 54px;
              border-radius: 50%;
              color: #fff;
              background-color: #f14724;
              font-size: 22px;
              text-transform: uppercase;
              display: flex;
              align-items: center;
              justify-content: center;
              background-size: cover;
              background-position: center;
              &.hasPhoto{
                span{
                  display: none;
                }
              }
            }
          }
        }
        h4, h5{
          margin: 0 20px;
          font-size: 20px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        h5{
          font-size: 15px;
          font-weight: normal;
          color: #767676;
          margin-bottom: 20px;
        }
        .amItem{
          list-style: none;
          padding: 10px 30px;
          cursor: pointer;
          display: block;
          .bl{
            float: right;
          }
          &:hover{
            background-color: #f5f5fe;
          }
          @media (max-width: 760px) {
            font-weight: 500;
            font-size: 18px;
            padding: 10px 20px;
          }
        }
        .divider{
          border-bottom: #eee 1px solid;
          margin-top: 10px;
          margin-bottom: 10px;
        }
        @media (max-width: 760px) {
          right: -54px;
          margin-top: 0;
          // position: fixed;
          // left: 0; right: 0; top: 51px; bottom: 0;
          // border-radius: 0;
          // box-shadow: none;
          // border-top: #eee 1px solid;
          // width: auto; margin: 0;
        }
      }

    }
    .searchCnt{
      position: absolute;
      right: 100px; top: 6px;
      width: 44px; height: 44px;
      transition: all .3s ease;
      border-radius: 50px;
      z-index: 17;
      &.loggedIn{
        right: 50px;
        @media (max-width: 1080px) {
          right: 66px;
        }
      }
      @media (max-width: 960px) {
        top: -1px;
      }
      @media (max-width: 1080px) {
        position: fixed;
        // background-color: #fff;
        border-radius: 0;
        right: 66px; top: 8px;
      }
      .searchDd{
        background-color: #fff;
        position: absolute;
        top: 100%; right: 10px; left: 0;
        border-radius: 10px;
        box-shadow: 2px 2px 4px rgba(0,0,0,.2);
        margin-top: 4px;
        padding: 10px 0;
        font-size: 17px;
        z-index: 2;
        max-height: 400px;
        display: none;
        .searchLoading{
          height: 160px;
          background-image: url(../assets/loading.svg);
          background-size: 40px auto;
          background-position: center;
          background-repeat: no-repeat;
        }
        .notFound{
          color: #444;
          padding: 20px 20px;
          position: static;
          transform: none;
          h4{
            margin: 0 0 6px;
            font-weight: normal;
            font-size: 20px;
          }
          p{
            margin: 0;
            font-size: 15px;
            line-height: 1.4;
            color: #767676;
          }
        }
        li{
          list-style: none;
          padding: 10px 20px;
          cursor: pointer;
          position: relative;
          padding-left: 80px;
          line-height: 1.4;
          min-height: 70px;
          box-sizing: border-box;
          .label{
            color: #767676;
            font-size: 14px;
            margin-top: -2px;
          }
          .icon{
            position: absolute;
            left: 20px; top: 12px;
            width: 46px; height: 46px;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            border-radius: 3px;
            background-color: #eee;
            &.teamUp{
              background-size: contain;
            }
            &.noImg{
              &:before{
                position: absolute;
                content: "";
                left: 0; right: 0; top: 0; bottom: 0;
                background-size: 24px auto;
                background-position: center;
                background-repeat: no-repeat;
                background-image: url(../assets/image-black.png);
                opacity: .3;
              }
            }
          }
          &:hover{
            background-color: #f5f5fe;
          }
          &.category{
            padding-left: 50px;
            .icon{
              background-image: url(../assets/empty-folder.svg);
              width: 20px; height: 20px;
              top: 9px; left: 20px;
            }
          }
          &.header{
            text-transform: uppercase;
            color: #888;
            font-weight: 500;
            font-size: 12px;
            padding: 16px 20px 6px;
            cursor: default;
            &:hover{
              background-color: #fff;
            }
            .icon{
              display: none;
            }
          }
        }
        @media (max-width: 760px) {
          right: 0;
          border-radius: 0;
          margin-top: 0;
          max-height: none;
          overflow: visible;
        }
      }
      form{
        position: relative;
        .searchLoading{
          position: absolute;
          width: 30px; height: 30px;
          border: none; border-radius: 50%;
          top: 5px; right: 10px;
          background-image: url(../assets/loading.svg);
          background-size: 22px auto;
          background-position: center;
          background-repeat: no-repeat;
          display: none;
        }
        &.searchLoading{
          button{
            display: none;
          }
          .searchLoading{
            display: block;
          }
        }
        input{
          border: #00468e 2px solid;
          background-color: #00468e;
          box-shadow: none;
          border-radius: 40px;
          padding-right: 50px;
          text-overflow: ellipsis;
          font-size: 18px;
          outline: 0 !important;
          width: 100%;
          box-sizing: border-box;
          transition: all .3s ease;
          display: none;

          /**
           * New
           *
           */
          padding: 9px 20px;
          @media (max-width: 760px) {
            // padding: 7px 20px;
          }
          &:hover{
            border-color: #5351a4;
          }
          &:focus{
            border-color: #fff;
            background-color: #fff;
            box-shadow: 2px 2px 2px rgba(0,0,0,.1);
          }

          /**
           * White version
           *
           */
          background-color: #eee;
          border-color: #eee;
          &:hover{
            border-color: #5351a4;
          }
          &:focus{
            border-color: #5351a4;
          }
        }
        .closeSearch{
          position: absolute;
          width: 44px; height: 44px;
          border: none; border-radius: 50%;
          top: 0; right: 2px;
          outline: 0;
          background-color: transparent;
          background-image: url(../assets/close.png);
          background-size: 12px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .6;
          display: none;
        }
        button{
          position: absolute;
          width: 40px; height: 40px;
          border: none; border-radius: 50%;
          top: 2px; right: 2px;
          padding: 0;
          outline: 0;
          background-color: transparent;
          background-image: url(../assets/search.png);
          background-size: 20px auto;
          background-position: center;
          background-repeat: no-repeat;
          box-sizing: border-box;
          box-shadow: none;
          &:hover{
            background-color: #eee;
          }
        }
      }
      .close{
        display: none;
      }
      &.open{
        width: 540px;
        .searchDd{
          display: block;
        }
        @media (max-width: 1080px) {
          width: 420px;
        }
        @media (max-width: 740px) {
          width: auto;
          left: 16px; right: 16px; top: 8px;
          button{
            display: none;
          }
          .closeSearch{
            display: block;
          }
        }
        form{
          input{
            display: block;
          }
        }
      }
    }
    .menuItem{
      border-radius: 5px;
      &.home{
        display: none;
        @media (max-width: 1080px) {
          display: block;
        }
      }
      a, .mi{
        cursor: pointer;
        display: block;
        font-weight: 500;
        font-size: 16px;
        padding: 12px 16px 10px;
        margin: 0 5px;
        color: #5351a4;
        font-weight: bold;
        text-transform: uppercase;
        transition: all .3s ease;
        border-radius: 5px;
        @media (max-width: 1080px) {
          font-size: 18px;
          padding: 20px 20px;
        }
        &:hover{
          background-color: rgba(0, 0, 0, .1);
        }
        .new{
          background-color: red;
          padding: 1px 5px;
          border-radius: 50px;
          color: #fff;
          font-size: 11px;
          float: right;
          margin: -4px 0 0 2px;
        }
      }
      &.active{
        // background-color: #f5f5fe;
        a{
          background-color: rgba(0, 0, 0, .1);
        }
      }
    }
  }
  .menuOverlay{
    background-color: #000;
    opacity: .65;
    position: fixed;
    left: 0; right: 0; top: 0; bottom: 0;
    z-index: 8;
  }
  .menuToggle{
    width: 44px; height: 44px;
    text-align: center;
    margin-left: 16px;
    box-sizing: border-box;
    padding-top: 5px;
    cursor: pointer;
    display: none;
    background-image: url(../assets/menu-lighter-purple.png);
    background-size: 24px auto;
    background-position: center;
    background-repeat: no-repeat;
    @media (max-width: 1080px) {
      display: block;
    }
  }
  .logo{
    display: block;
    text-align: left;
    transition: all .3s ease;
    font-size: 36px;
    margin-right: 20px;
    img{
      height: 40px;
      @media (max-width: 680px) {
        height: 32px;
        margin-top: -4px;
      }
    }
    @media (max-width: 960px) {
      margin-top: 8px;
    }
    @media (max-width: 680px) {
      font-size: 26px;
    }
  }
}
.scrolled header{
  background-color: #fff;
  box-shadow: 0 0 6px rgba(0,0,0,.2);
  height: 60px;
  .searchCnt{
    top: -1px;
    @media (max-width: 1080px) {
      top: 8px;
    }
  }
  .logo{
    margin-top: 8px;
  }
  .menuCnt{
    padding-top: 0;
  }
}
</style>
